// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const sandslash_alola: PokeData = {
  "id": 10102,
  "name": "sandslash-alola",
  "height": 12,
  "weight": 550,
  "base_experience": 158,
  "types": [
    PokeType.ICE,
    PokeType.STEEL
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "mist",
    "blizzard",
    "counter",
    "defense-curl",
    "bide",
    "swift",
    "fury-swipes",
    "slash",
    "powder-snow",
    "rollout",
    "fury-cutter",
    "rapid-spin",
    "metal-claw",
    "hail",
    "ice-ball",
    "icicle-spear",
    "iron-defense",
    "gyro-ball",
    "metal-burst",
    "ice-shard",
    "iron-head",
    "icicle-crash"
  ],
  "moves": [
    "scratch",
    "blizzard",
    "metal-claw",
    "metal-burst",
    "ice-shard",
    "sheer-cold",
    "behemoth-bash",
    "avalanche",
    "smart-strike",
    "metal-rush",
    "hailstorm",
    "ice-fang"
  ],
  "evolution_chain": {
    "id": 11,
    "item": null,
    "species": [
      {
        "name": "sandshrew",
        "order": 28,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sandslash",
        "order": 29,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 27,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 135,
    "speed": 105,
    "ability_power": 161
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
